var _circle, _path, _path2, _path3, _g, _circle2, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 112,
    viewBox: "0 0 130 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 56,
    r: 44,
    fill: "#EAEEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.528 37.166C115.589 37.166 117.259 35.4955 117.259 33.4348C117.259 31.3741 115.589 29.7036 113.528 29.7036C111.467 29.7036 109.797 31.3741 109.797 33.4348C109.797 35.4955 111.467 37.166 113.528 37.166Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.986 22.6048C120.393 22.6048 121.534 21.464 121.534 20.0567C121.534 18.6494 120.393 17.5085 118.986 17.5085C117.578 17.5085 116.438 18.6494 116.438 20.0567C116.438 21.464 117.578 22.6048 118.986 22.6048Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.201 18.4645C28.8145 18.4645 30.9332 16.3458 30.9332 13.7322C30.9332 11.1187 28.8145 9 26.201 9C23.5874 9 21.4688 11.1187 21.4688 13.7322C21.4688 16.3458 23.5874 18.4645 26.201 18.4645Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34290_122247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 54.5641C90.8649 54.5527 90.7293 54.5469 90.5938 54.547H80.8438C78.1515 54.547 75.9688 56.7972 75.9688 59.5726C75.9688 62.348 78.1515 64.5983 80.8438 64.5983H90.5938C90.7307 64.5983 90.8659 64.5924 91 64.5811V72.9743C91 75.7498 88.8172 78 86.125 78H43.875C41.1828 78 39 75.7498 39 72.9743V46.1709C39 43.3955 41.1828 41.1452 43.875 41.1452H86.125C88.8172 41.1452 91 43.3955 91 46.1709V54.5641ZM87.1861 38.6324H46.2443C46.7394 38.2581 47.2985 37.9833 47.8924 37.8224L79.6498 29.1699C82.2482 28.4622 84.9188 30.0297 85.6156 32.672L87.1861 38.6324ZM80.8438 56.2222H89.375C89.806 56.2222 90.2193 56.3987 90.5241 56.7128C90.8288 57.027 91 57.4531 91 57.8974V61.2478C91 61.6921 90.8288 62.1182 90.5241 62.4324C90.2193 62.7466 89.806 62.923 89.375 62.923H80.8438C79.9818 62.923 79.1551 62.5701 78.5457 61.9417C77.9362 61.3134 77.5938 60.4612 77.5938 59.5726C77.5938 58.684 77.9362 57.8318 78.5457 57.2035C79.1551 56.5752 79.9818 56.2222 80.8438 56.2222ZM81.25 61.6666C81.7887 61.6666 82.3054 61.446 82.6863 61.0533C83.0672 60.6606 83.2813 60.128 83.2813 59.5726C83.2813 59.0172 83.0672 58.4846 82.6863 58.0919C82.3054 57.6992 81.7887 57.4786 81.25 57.4786C80.7113 57.4786 80.1946 57.6992 79.8137 58.0919C79.4328 58.4846 79.2188 59.0172 79.2188 59.5726C79.2188 60.128 79.4328 60.6606 79.8137 61.0533C80.1946 61.446 80.7113 61.6666 81.25 61.6666Z",
    fill: "url(#paint0_linear_34290_122247)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.412,
    cy: 76.4093,
    r: 11.2188,
    transform: "rotate(-1.72903 104.412 76.4093)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.086 63.014C112.743 63.065 118.932 69.2921 118.895 76.9081C118.858 84.5564 112.615 90.7682 105.008 90.724C97.3238 90.6815 91.1307 84.4119 91.2038 76.7534C91.2769 69.1459 97.5244 62.963 105.086 63.014ZM96.4228 80.9864C96.5435 82.6456 97.3408 84.0651 99.0255 84.8488C100.673 85.6155 102.334 85.4744 103.7 84.2827C105.139 83.0281 106.477 81.6443 107.743 80.2146C108.79 79.0331 108.909 77.5762 108.435 76.087C108.126 75.1163 107.541 74.744 106.776 74.9888C106.052 75.2217 105.807 75.8133 106.075 76.7738C106.303 77.583 106.245 78.3344 105.642 78.9549C104.554 80.0752 103.468 81.2006 102.329 82.2665C101.453 83.0859 100.238 83.0383 99.4726 82.2512C98.6855 81.442 98.6821 80.1993 99.4845 79.317C99.8738 78.8886 100.311 78.5027 100.705 78.0794C101.208 77.5405 101.207 76.7874 100.727 76.3199C100.272 75.8762 99.5406 75.8626 99.0204 76.3437C98.4849 76.8401 97.9664 77.3586 97.4853 77.906C96.7611 78.7339 96.433 79.725 96.4228 80.9864ZM101.609 76.0377C101.626 76.2077 101.643 76.5358 101.7 76.8571C101.737 77.0781 101.817 77.294 101.9 77.5031C102.22 78.3123 102.861 78.6676 103.541 78.4228C104.166 78.1984 104.454 77.5167 104.202 76.7313C103.894 75.7657 104.105 74.9548 104.816 74.2459C105.815 73.2514 106.8 72.2382 107.806 71.2488C108.671 70.3971 109.921 70.3495 110.727 71.1128C111.563 71.905 111.585 73.1715 110.757 74.098C110.388 74.5111 109.97 74.8783 109.593 75.2846C109.055 75.8609 109.042 76.5426 109.533 77.0356C110.045 77.5473 110.727 77.5813 111.281 77.0526C111.862 76.4967 112.438 75.9255 112.933 75.2948C114.31 73.5387 114.084 70.9309 112.464 69.3805C110.82 67.8063 108.241 67.6635 106.55 69.1527C105.247 70.3002 104.023 71.5412 102.813 72.7873C101.995 73.6322 101.618 74.6964 101.609 76.0377Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34290_122247",
    x: 22.6691,
    y: 20.8346,
    width: 84.6617,
    height: 81.6617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.16543
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.16543
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34290_122247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34290_122247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34290_122247",
    x1: 64.9831,
    y1: 27.8666,
    x2: 64.9831,
    y2: 78.5283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnected);
export default __webpack_public_path__ + "static/media/not-connected.9d705755a5733ddb0221e5db190c4f0f.svg";
export { ForwardRef as ReactComponent };